import React from 'react';
import styled from 'styled-components';
import { Chart } from '../../../../shared/styles/chart/chart';

const CircleChartsSection = styled.section`
    text-align: center;
    padding-top: 64px;
    padding-bottom: 64px;
    
    h2 {
        font-weight: 800;
        font-size: 48px;
        line-height: 64px;
        margin-top: 0;
        margin-bottom: 8px;
    }
    h3 {
        font-size: 18px;
        line-height: 32px;
        font-weight: 500;
        margin-top: 0;
        margin-bottom: 24px;
    }

    .charts-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        column-gap: 84px;
        row-gap: 48px;
        margin-top: 64px;
        margin-bottom: 32px;
        flex-wrap: wrap;
    }
    
`;

const CircleCharts = () => {
    return (
        <CircleChartsSection>
            <h2>Daten & Fakten zum STELL-MICH-EIN</h2>
            <h3>Teilnehmerbefragung (Unternehmen und Talents) nach unseren Speed-Recruitings im Februar/März 2022</h3>
            <div className='charts-container'>
                <Chart>
                    <div className="percent">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="-1 -1 34 34">
                            <circle cx="16" cy="16" r="15.9155" className="progress-bar__background"></circle>
                            <circle cx="16" cy="16" r="15.9155" className="progress-bar__progress" style={{ strokeDashoffset: 0 }}></circle>
                        </svg>
                        <div className="number">
                            <span>100<span>%</span></span>
                        </div>
                    </div>
                    <p>empfehlen das STELL-MICH-EIN anderen</p>
                </Chart>
                <Chart>
                    <div className="percent">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="-1 -1 34 34">
                            <circle cx="16" cy="16" r="15.9155" className="progress-bar__background"></circle>
                            <circle cx="16" cy="16" r="15.9155" className="progress-bar__progress" style={{ strokeDashoffset: 15 }}></circle>
                        </svg>
                        <div className="number">
                            <span>85<span>%</span></span>
                        </div>
                    </div>
                    <p>der Bewerber*innen finden im Anschluss an das STELL-MICH-EIN einen Job</p>
                </Chart>
                <Chart>
                    <div className="percent">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="-1 -1 34 34">
                            <circle cx="16" cy="16" r="15.9155" className="progress-bar__background"></circle>
                            <circle cx="16" cy="16" r="15.9155" className="progress-bar__progress" style={{ strokeDashoffset: 64 }}></circle>
                        </svg>
                        <div className="number">
                            <span>36<span>%</span></span>
                        </div>
                    </div>
                    <p>der Bewerber*innen finden direkt am STELL-MICH-EIN-Eventtag einen Job</p>
                </Chart>
            </div>

        </CircleChartsSection>
    )
}

export default CircleCharts